import { Instant } from '../types';

export interface InstantsCache {
  items: Instant[];
  nextCursor: string | null;
  hasMore: boolean;
}

const TTL = 5 * 60 * 1000;
const key = (userId: number) => `instants-feed-v1-${userId}`;

export function getCachedInstants(userId?: number): InstantsCache | null {
  if (!userId) return null;
  try {
    const parsed = JSON.parse(localStorage.getItem(key(userId)) || 'null');
    if (!parsed || Date.now() - Number(parsed.savedAt) > TTL) return null;
    const now = Date.now();
    return {
      items: (parsed.items ?? []).filter((item: Instant) => new Date(item.expires_at).getTime() > now),
      nextCursor: parsed.nextCursor ?? null,
      hasMore: parsed.hasMore !== false,
    };
  } catch {
    return null;
  }
}

export function saveCachedInstants(userId: number | undefined, cache: InstantsCache): void {
  if (!userId) return;
  try {
    localStorage.setItem(key(userId), JSON.stringify({ ...cache, savedAt: Date.now() }));
  } catch {
    // Cache is optional.
  }
}
